import React from "react";

import { Minimize, Maximize } from "../../svg/svgImageList";
import Tooltip, { ComponentWithTooltipProps } from "../../tooltip/Tooltip";
import Button from "../../button/Button";

interface EnterExitFulscreenProps extends ComponentWithTooltipProps {
  isFullscreen: boolean;
  enter(): void;
  exit(): void;
}

const elementId = "video-fullscreen-control";

export default function EnterExitFullscreen(props: EnterExitFulscreenProps) {
  const { isFullscreen, enter, exit, tooltipTextKey } = props;

  return (
    <Tooltip id={elementId} title={tooltipTextKey}>
      <Button
        id={elementId}
        onClick={isFullscreen ? exit : enter}
        icon={{
          svg: isFullscreen ? Minimize : Maximize,
          className: "video-control-item fullscreen",
        }}
      />
    </Tooltip>
  );
}
